export const CLASSIC_SESSION = 'Session::Classic';
export const CAT_SESSION = 'Session::CatMh';
export const RA_SESSION = 'Session::ResearchAssistant';

export const CAT_SESSION_NAME_PREFIX = '(CAT-MH™)';
export const CAT_SESSION_BDI_NAME_PREFIX = '<bdi>(CAT-MH™)</bdi>';
